import http from "../components/config/axiosConfig";
import {v4 as uuidv4} from 'uuid';

const getWebsocketUri = () => {
    let connectionString = `wss://${window.location.hostname}/webSocket/${uuidv4()}`

    if (window.location.protocol !== 'https:') {
        connectionString = `ws://${window.location.hostname}:8080/webSocket/${uuidv4()}`
    }
    return connectionString
};

const sendScreenSize = data => {
    return http.post('/connect', data)
};

const connection = {
    getWebsocketUri,
    sendScreenSize
};

export default connection